module.exports = __webpack_public_path__ + "public/Icons/userIcon.png?a15c4288";